import { render } from "./codes.vue?vue&type=template&id=455b232e&scoped=true&ts=true"
import script from "./codes.vue?vue&type=script&lang=ts"
export * from "./codes.vue?vue&type=script&lang=ts"

import "./codes.vue?vue&type=style&index=0&id=455b232e&scoped=scoped&lang=css"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b232e"]])

export default __exports__